import React, { useMemo, useState } from "react";
import { Bug, Download } from "lucide-react";

export function DebugTrace({ lines, meta }) {
    const [open, setOpen] = useState(false);
    const [filter, setFilter] = useState("");
    const shown = useMemo(() => {
        const f = filter.trim().toLowerCase();
        return f ? lines.filter((l) => l.toLowerCase().includes(f)) : lines;
    }, [lines, filter]);

    const download = () => {
        const blob = new Blob([lines.join("\n")], { type: "text/plain;charset=utf-8" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        const base = (meta?.dxfName || "computo").replace(/\.[^.]+$/, "");
        a.download = `traccia_debug_${base}_${new Date().toISOString().slice(0, 10)}.txt`;
        a.click();
        URL.revokeObjectURL(url);
    };

    return (
        <div className="border border-slate-300 bg-slate-900 text-slate-100" data-testid="debug-trace">
            <div className="flex flex-wrap items-center gap-3 px-4 py-3 border-b border-white/10">
                <button onClick={() => setOpen((o) => !o)} data-testid="debug-trace-toggle"
                    className="inline-flex items-center gap-2 text-sm font-medium text-white hover:text-cb-accent transition-colors">
                    <Bug size={16} className="text-cb-accent" /> Traccia di debug · {lines.length} passaggi {open ? "▾" : "▸"}
                </button>
                {open && (
                    <input value={filter} onChange={(e) => setFilter(e.target.value)} placeholder="filtra (es. s12, larghezza, 300x900)"
                        data-testid="debug-trace-filter"
                        className="bg-white/5 border border-white/15 text-xs text-white placeholder:text-slate-500 px-3 py-1.5 focus:outline-none focus:border-cb-accent w-64" />
                )}
                <button onClick={download} data-testid="debug-trace-download"
                    className="ml-auto inline-flex items-center gap-1.5 text-xs text-slate-300 hover:text-white border border-white/15 hover:border-white/40 px-3 py-1.5 transition-colors">
                    <Download size={12} /> Scarica .txt
                </button>
            </div>
            {open && (
                <pre className="max-h-[480px] overflow-auto text-[11px] leading-relaxed font-mono p-4 whitespace-pre-wrap break-words" data-testid="debug-trace-body">
                    {shown.slice(0, 4000).join("\n")}
                    {shown.length > 4000 ? `\n... ${shown.length - 4000} righe non mostrate (scarica il file completo)` : ""}
                </pre>
            )}
        </div>
    );
}
